<particle-tree-selector class="flex-1-0-350px"
                        [title]="solutionSelectorTitle"
                        [displayProperty]="'name'"
                        [treeData]="solutionSelectorData$"
                        [itemViewerName]="itemViewerName"
                        [quickSelections]="quickSelections$"
                        [isParentNodeCollapsible]="isParentNodeCollapsible$"
                        (selectionChanged)="onProjectSelectionChanged($event)"
                        (quickSelectionClicked)="onQuickSelectionClick($event)">
</particle-tree-selector>
